import { apiClient } from "../config";

async function addBrand(body: any): Promise<any> {
  const res = await apiClient.post(`/admin/brands`, body);
  return res.data;
}

export default addBrand;